import React from 'react';
import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
  chartWrapper: {
    stroke: '#4b8c6f',
    height: 38,
    width: 38,
    cursor: 'pointer',
  },
  circleBg: {
    fill: 'none',
    stroke: '#eee',
    strokeWidth: 1.75,
  },
  circle: {
    fill: 'none',
    strokeWidth: 1.75,
    strokeLinecap: 'round',
    animation: `$progress 1s ease-out forwards`,
  },

  '@keyframes progress': {
    '0%': {
      strokeDasharray: '0 100',
    },
  },
  percentage: {
    fill: '#49515a',
    stroke: 'none',
    fontSize: '0.85em',
    textAnchor: 'middle',
    alignmentBaseline: 'middle',
    fontWeight: 500,
  },
}));

const SvgCircle = ({ match = 0 }) => {
  const classes = useStyles();

  return (
    <svg viewBox="0 0 36 36" className={classes.chartWrapper}>
      <path
        className={classes.circleBg}
        d="M18 2.0845
          a 15.9155 15.9155 0 0 1 0 31.831
          a 15.9155 15.9155 0 0 1 0 -31.831"
      />
      <path
        className={classes.circle}
        strokeDasharray={`${match}, 100`}
        d="M18 2.0845
          a 15.9155 15.9155 0 0 1 0 31.831
          a 15.9155 15.9155 0 0 1 0 -31.831"
      />
      <text x="18" y="20.35" className={classes.percentage}>
        {Math.round(match)}%
      </text>
    </svg>
  );
};

export default SvgCircle;
